import React from 'react'
import flow from 'lodash/flow'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { logout } from '../../state/user'
import auth from '../../lib/auth'

const stateToProps = state => ({
    user: state.user
})

const actionsToProps = dispatch => ({
  logout: () => dispatch(logout())
})

class Logout extends React.Component {

  componentDidMount() {
    auth.logout(this.props.user.name)
    .then(res => {
      auth.loggedOut()
      this.props.logout()
      this.props.history.replace('/login')
    })
  }

  render() {
    return null
  }
}

const decorators = flow([
  connect(stateToProps, actionsToProps),
  withRouter
])

export default decorators(Logout)



// WEBPACK FOOTER //
// ./src/components/auth/Logout.js